/**
 * Export the measurement overlay canvas as a shareable image with watermark.
 */

/**
 * Draw a "Measured by FitAfrica" watermark onto a canvas and return as Blob.
 */
export async function exportOverlayImage(
  sourceCanvas: HTMLCanvasElement,
  watermarkText = 'Measured by FitAfrica'
): Promise<Blob> {
  // Create a copy so we don't mutate the displayed canvas
  const w = sourceCanvas.width;
  const h = sourceCanvas.height;
  const offscreen = document.createElement('canvas');
  offscreen.width = w;
  offscreen.height = h;
  const ctx = offscreen.getContext('2d')!;

  // Copy source
  ctx.drawImage(sourceCanvas, 0, 0);

  // Draw watermark in bottom-right
  const fontSize = Math.max(12, Math.round(w * 0.03));
  ctx.font = `bold ${fontSize}px system-ui, -apple-system, sans-serif`;
  ctx.textAlign = 'right';
  ctx.textBaseline = 'bottom';

  const padding = Math.round(w * 0.04);
  const x = w - padding;
  const y = h - padding;

  // Shadow for readability
  ctx.shadowColor = 'rgba(0, 0, 0, 0.5)';
  ctx.shadowBlur = 4;
  ctx.shadowOffsetX = 1;
  ctx.shadowOffsetY = 1;
  ctx.fillStyle = 'rgba(255, 255, 255, 0.7)';
  ctx.fillText(watermarkText, x, y);

  // Reset shadow
  ctx.shadowColor = 'transparent';
  ctx.shadowBlur = 0;

  return new Promise<Blob>((resolve, reject) => {
    offscreen.toBlob(
      (blob) => {
        if (blob) resolve(blob);
        else reject(new Error('Canvas export failed'));
      },
      'image/png'
    );
  });
}
